export default __webpack_public_path__ + "d92629440383e4fc85e0a408ff6ecfa8.png";